import { configureStore } from '@reduxjs/toolkit';
import lang from './lang';


export const store = configureStore({
  reducer: { lang },
});
